import React from "react";
import NewTopNavBar from "./NewTopNavBar";
import { Base_Url } from "../utils/config";

const KrLanding = () => {
  return (
    <div>
      <NewTopNavBar />

      <div className=" " style={{ height: "88vh" }}>
        <iframe
          className="h-100 w-100"
          // src={`${Base_Url}/chatai`}
          // src="https://kr.camptratech.com/chatai"
          src={`${window.location.origin}/chatai`}
        ></iframe>
      </div>
    </div>
  );
};

export default KrLanding;
